import { CustomerController, NewsController } from "../../controllers";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";
import React, { useState } from "react";
import { observer } from "mobx-react";
import { DeleteNews } from "../../pages";
import { adminStore } from "../../stores";
import { toJS } from "mobx";

const DeleteNewsContainer = ({ closeModal }) => {
  const [loading, setLoading] = useState(false);

  const onDelete = async (id) => {
    setLoading(true);
    const { status, errorMessage } = await NewsController.deleteNews(id);

    if (status === constant.Success) {
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
      return closeModal();
    }
    setLoading(false);
    return MimaToastUtil.error({
      message: errorMessage,
    });
  };

  return (
    <DeleteNews
      closeModal={closeModal}
      loading={loading}
      onDelete={onDelete}
      selectedNews={toJS(adminStore.singleNews)}
    />
  );
};

export default observer(DeleteNewsContainer);
